import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { addOrder } from "../dataSource/OrderSource";
import { fetchProducts } from "../dataSource/ProductSource";
import PaymentMethodSelector from "./PaymentMethodSelector";
import { validateCoupon } from '../dataSource/CouponSource';
import ShippingOptions from "./ShippingOptions";
import ShippingOptionsBasic from "./ShippingOptionsBasic";
import CartBasic from "./CartBasic";
import { CartContext } from "../util/cartContext";
import "./styling/details.css";
import "./styling/details-s.css";
import arrow from "../pages/product pages/assets/arrow-back.svg";
import { ClipLoader } from 'react-spinners';

const OrderDetails = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [differentShippingAddress, setDifferentShippingAddress] = useState(false);
  const [addressComplete, setAddressComplete] = useState(false);
  const [paymentMethodComplete, setPaymentMethodComplete] = useState(false);
  const [shippingComplete, setShippingComplete] = useState(false);
  const [confirmedAge, setConfirmedAge] = useState(false);
  const [shippingOption, setShippingOption] = useState([]);
  const [hasItems, setHasItems] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [couponStatusMessage, setCouponStatusMessage] = useState("");

  const [isPickup, setIsPickup] = useState(false);
  const [totalOrderPrice, setTotalOrderPrice] = useState(0.00);
  const [coupon, setCoupon] = useState('');  
  const [couponDiscount, setCouponDiscount] = useState(0); 

  const canPlaceOrder = addressComplete && paymentMethodComplete && confirmedAge && shippingComplete && hasItems;

  // Order variables
  const [firstName, setFirstName] = useState("");
  const [preposition, setPreposition] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [streetName, setStreetName] = useState("");
  const [houseNumber, setHouseNumber] = useState("");
  const [houseNumberAddition, setHouseNumberAddition] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [country, setCountry] = useState("");
  const [note, setNote] = useState("");
  const [city, setCity] = useState("");
  const [companyName, setCompanyName] = useState("");

  const [shippingFirstName, setShippingFirstName] = useState("");
  const [shippingPreposition, setShippingPreposition] = useState("");
  const [shippingLastName, setShippingLastName] = useState("");
  const [shippingStreetName, setShippingStreetName] = useState("");
  const [shippingHouseNumber, setShippingHouseNumber] = useState("");
  const [shippingHouseNumberAddition, setShippingHouseNumberAddition] = useState("");
  const [shippingZipcode, setShippingZipcode] = useState("");
  const [shippingCountry, setShippingCountry] = useState("");
  const [shippingCity, setShippingCity] = useState("");
  const [shippingCompanyName, setShippingCompanyName] = useState("");

  // const [firstName, setFirstName] = useState("Test");
  // const [preposition, setPreposition] = useState("");
  // const [lastName, setLastName] = useState("Order");
  // const [phoneNumber, setPhoneNumber] = useState("1234567890");
  // const [emailAddress, setEmailAddress] = useState("prod.goldweb@gmail.com");
  // const [streetName, setStreetName] = useState("Molengraaffplantsoen");
  // const [houseNumber, setHouseNumber] = useState("74");
  // const [houseNumberAddition, setHouseNumberAddition] = useState("A");
  // const [zipcode, setZipcode] = useState("3571ZZ");
  // const [country, setCountry] = useState("NL");
  // const [note, setNote] = useState("");
  // const [city, setCity] = useState("Utrecht");
  // const [companyName, setCompanyName] = useState("Example Company");
  

  // const [shippingFirstName, setShippingFirstName] = useState("Bart");
  // const [shippingPreposition, setShippingPreposition] = useState("van");
  // const [shippingLastName, setShippingLastName] = useState("Dijk");
  // const [shippingStreetName, setShippingStreetName] = useState("Molengraaffplantsoen");
  // const [shippingHouseNumber, setShippingHouseNumber] = useState("74");
  // const [shippingHouseNumberAddition, setShippingHouseNumberAddition] = useState("A");
  // const [shippingZipcode, setShippingZipcode] = useState("3571ZZ");
  // const [shippingCountry, setShippingCountry] = useState("NL");
  // const [shippingCity, setShippingCity] = useState("Utrecht");
  // const [shippingCompanyName, setShippingCompanyName] = useState("Example Company");

  const [isOrdering, setIsOrdering] = useState(false);
  const [orderPrice, setOrderPrice] = useState(""); // Added
  const [orderLines, setOrderLines] = useState([]); // Added
  const [status, setStatus] = useState(""); // Added
  const [paymentStatus, setPaymentStatus] = useState(""); // Added
  const [paymentId, setPaymentId] = useState(""); // Added
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const { cart, addToCart, removeFromCart, clearCart, totalPrice, shippingCost } = useContext(CartContext);
  const [selectedPaymentMethod, setSelectedMethod] = useState('');

  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 1200px)").matches
  );

  const checkStockBeforeOrder = async () => {
    try {
      const latestProducts = await fetchProducts(); // Get updated stock
      const stockIssues = [];
  
      cart.forEach(item => {
        const latestProduct = latestProducts[item.id];
        if (latestProduct && latestProduct.product_info.stock !== null) {
          if (latestProduct.product_info.stock < item.quantity) {
            stockIssues.push(`Iemand was u helaas net voor. ${item.name} heeft nog maar ${latestProduct.product_info.stock} stuks op voorraad.`);
          }
        }
      });
  
      if (stockIssues.length > 0) {
        setStatusMessage(stockIssues.join("\n")); // Show stock warning
        return false;
      }
  
      return true;
    } catch (error) {
      console.error("Error checking stock:", error);
      return false;
    }
  };

  const checkCouponBeforeOrder = async () => {

    try {

      if(coupon.code){

        const result = await validateCoupon(coupon.code);

       if (result.coupon) {

          let newCoupon = result.coupon;

          if (newCoupon.status !== "active") {
            setCouponStatusMessage("De toegepaste coupon is niet (meer) actief.");
             return false;
          }
      
          if (newCoupon.usage_limit != null) {
      
            if(newCoupon.usage_count >= newCoupon.usage_limit){
              setCouponStatusMessage("De toegepaste coupon is al gebruikt.");
              return false;
            }
          }
      
          const currentDate = new Date();
          const startDate = new Date(newCoupon.start_date);
          const endDate = new Date(newCoupon.end_date);
      
          const formatDate = (date) => {
            return date.toLocaleDateString("nl-NL", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            });
          };
      
          if (currentDate < startDate) {
            setCouponStatusMessage("De gebruikte coupon is geldig vanaf: " + formatDate(startDate));
            return false;
          }
      
          if (currentDate > endDate) {
            setCouponStatusMessage("De gebruikte coupon is verlopen op: " + formatDate(endDate));
            return false;
          }
      
          let applicableCartItems = [];
      
          if (newCoupon.applicable_products === "ALL_PRODUCTS") {
            applicableCartItems = cart;
          } else if (Array.isArray(newCoupon.applicable_products)) {
            applicableCartItems = cart.filter(item => 
              newCoupon.applicable_products.includes(item.id)
            );
          } else {
            applicableCartItems = [];
          }
            
          if (applicableCartItems.length == 0){
            setCouponStatusMessage(`Coupon niet toepasbaar op producten in winkelwagentje.`);
            return false;
          }   

          return true;
        
        } else{
          setCouponStatusMessage("Fout bij verifiëren van coupon.");
          return false;
        }

      }else{
        return true;
      }      

    } catch (error) {
      console.log("Error verifying coupon: ", error);
      return true;
    }       
  };


  useEffect(() => {
    
    if(isPickup){
      setTotalOrderPrice(totalPrice);
    }else{
      setTotalOrderPrice(totalPrice + shippingCost);
    }    

  }, [totalPrice, shippingCost, isPickup]);

  useEffect(() => {
    setHasItems(cart.length > 0); 
  }, [cart]); 

  useEffect(() => {
    
  }, [shippingOption]);


   const handleSubmitDetails = async (e) => {
    e.preventDefault();
    setAddressComplete(true);
  };

  // Handle the change event to update the state
  const handleDifferentAddressCheckboxChange = (event) => {
    setDifferentShippingAddress(event.target.checked);
  };
  
  const handleAgeCheckboxChange = (event) => {
    setConfirmedAge(event.target.checked);
  };

  useEffect(() => {
    setShippingComplete(true);

    console.log("shipping option picked");

    if (shippingOption === "winkel"){
      setIsPickup(true)
    } else {
      setIsPickup(false)
    }

  }, [shippingOption]);

  useEffect(() => {

    if(selectedPaymentMethod != ''){
    setPaymentMethodComplete(true);
    } else {
      setPaymentMethodComplete(false);
    }
    
  }, [selectedPaymentMethod]);


  const generateShippingData = () => {

    let weight = cart.length * 1200;
    
    let shippingData = {};

    try {

      console.log("Shippingoptions to make url with: ", shippingOption);

      if(shippingOption === 'Delivery'){
        shippingData.delivery_options = 'Delivery';
        shippingData.weight = weight;  
        shippingData.product_code_delivery = '3449';
        shippingData.delivery_date = '';
        shippingData.location_code = '';
      } else if (shippingOption === 'winkel') {
       
        shippingData.delivery_options = 'Pickup';
          shippingData.weight = weight;  
          shippingData.product_code_delivery = '3574';
          shippingData.delivery_date = '';        
          shippingData.location_code = '';
      } else {
          throw new Error("Invalid shipping option data");
      }

      // if (shippingOption.DeliveryDate && shippingOption.Timeframe) {

      //   // This is a delivery
      //   shippingData.delivery_options = 'Daytime';
      //   shippingData.weight = weight;  
      //   shippingData.product_code_delivery = '3449';
      //   shippingData.delivery_date = shippingOption.DeliveryDate;
      //   shippingData.location_code = '';

      // } else if (shippingOption.address && shippingOption.location_code) {

      //     shippingData.delivery_options = 'Pickup';
      //     shippingData.weight = weight;  
      //     shippingData.product_code_delivery = '3574';
      //     shippingData.delivery_date = '';        
      //     shippingData.location_code = shippingOption.location_code;

      // } else {
      //     throw new Error("Invalid shipping option data");
      // }
      
    } catch (error) {
      console.log("Error extracting shipping Data: ", error);
    } 

    return shippingData;
};
  


  const placeOrder = async () => {

    const maxRetries = 3; // Number of retry attempts
    const retryDelay = 1000; // Delay between retries in milliseconds
    setIsOrdering(true);
    setStatusMessage("");

    const stockOk = await checkStockBeforeOrder();
    if (!stockOk) {
    setIsOrdering(false);
    return;
    }

    const couponOk = await checkCouponBeforeOrder();
    if (!couponOk) {
    setIsOrdering(false);
    return;
    }
  
    try {
      let addressData = {};
      let shippingAddressData = {};
      let shippingData = {};
      let customerData = {};
      let orderLines = {};
  
      // Step 1: Prepare Data
      try {
        addressData = {         
          shippingAddress: differentShippingAddress ? 0 : 1,
          streetName: streetName,
          houseNumber: houseNumber,
          houseNumberAddition: houseNumberAddition,
          zipcode: zipcode,
          city: city,
          country: country
        };
  
        if (differentShippingAddress) {
          shippingAddressData = {      
            shippingAddress: 1,
            streetName: shippingStreetName,
            houseNumber: shippingHouseNumber,
            houseNumberAddition: shippingHouseNumberAddition,
            zipcode: shippingZipcode,
            city: shippingCity,
            country: shippingCountry,
            firstName: shippingFirstName,
            preposition: shippingPreposition,
            lastName: shippingLastName,
            companyName: shippingCompanyName
          };
        }
  
        // Overwrite shipping address data if a pickup point is selected
        if (shippingOption.address && shippingOption.location_code) {
          shippingAddressData = {      
            shippingAddress: 1,
            streetName: shippingOption.address.street,
            houseNumber: shippingOption.address.house_nr,
            houseNumberAddition: '',
            zipcode: shippingOption.address.zipcode,
            city: shippingOption.address.city,
            country: shippingOption.address.countrycode,
            firstName: shippingFirstName,
            preposition: shippingPreposition,
            lastName: shippingLastName,
            companyName: shippingOption.name
          };
          addressData.shippingAddress = 0;
        }
  
        shippingData = generateShippingData();

      } catch (error) {
        console.log("Error creating data", error);
        setIsOrdering(false);
        return; // Stop function if data preparation fails
      }
  
      // Step 2: Set Customer Data and Order Lines
      customerData = {
        firstName: firstName,
        preposition: preposition,
        lastName: lastName,
        phoneNumber: phoneNumber,
        emailAddress: emailAddress,
        companyName: companyName
      };
  
      orderLines = cart.flatMap(item =>
        Array.from({ length: item.quantity }, () => ({ productId: item.id, cost: item.price }))
      );
  
      setTotalOrderPrice(totalPrice + shippingCost);    
  
      const redirectUrl = 'http://pulcinos.nl/thankyou';
      //const redirectUrl = 'http://localhost:3000/thankyou';
  
      // Step 3: Attempt to Place Order with Retry Mechanism
      let response;
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        console.log("Trying, attempt:", attempt);

        console.log("adding order with shippingdata: ", shippingData);
      
        try {

          response = await addOrder(
            totalOrderPrice.toFixed(2), note, customerData, addressData, 
            shippingAddressData, shippingData, orderLines, selectedPaymentMethod, redirectUrl, coupon, couponDiscount
          );

          // response = await addOrder(
          //     '0.01', note, customerData, addressData, 
          //     shippingAddressData, shippingData, orderLines, selectedPaymentMethod, redirectUrl, coupon, couponDiscount
          //   );
      
          if (response && response.payment_url && response.payment_url[0]) {
            console.log("Payment URL found");
            window.location.href = response.payment_url[0];
            setIsOrdering(false); // Successfully redirected, stop the function
            return;
          } else {
            console.log("No URL returned, response:", response);
            if (attempt === maxRetries) {
              console.error("Failed to retrieve a valid payment URL after multiple attempts.");
              setIsOrdering(false);
            }
          }
      
        } catch (error) {
          console.log(`Attempt ${attempt} failed: Error creating order`, error);
      
          // Wait before retrying if it's not the last attempt
          if (attempt < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          } else {
            console.log("All retry attempts failed.");
            setIsOrdering(false);
          }
        }
      }

      setIsOrdering(false);
  
      if (!response || !response.payment_url) {
        console.error("Order placed without a valid payment URL:", response);
        setStatusMessage("Er iets fout gegaan...");
      }      
  
    } catch (error) {
      console.log("Unexpected error in placeOrder:", error);
      setIsOrdering(false);
    }

  };
  

  return (
    <>

    {!isMobile && (
    <div className="desktopNavSpacer"></div>
     )}
       <div className="back">
        <Link
          className="hightlightsLink"
          to="/cart"
          style={{
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img src={arrow} alt=""></img>
          <p>Terug</p>
        </Link>
      </div>
    <div id="detailsWrapper">
    <div id="detailsBox">
      <div className="detailsColumn">
        <CartBasic pickUp={isPickup} totalOrderPrice={totalOrderPrice} 
        setTotalOrderPrice={setTotalOrderPrice} coupon={coupon} setCoupon={setCoupon}
        couponDiscount={couponDiscount} setCouponDiscount={setCouponDiscount}/>

        <h4>Bestelnotitie: (optioneel)</h4>
        <textarea
          placeholder="Opmerkingen over uw bestelling, zoals specifieke instructies voor de levering."
          required
          value={note}
          onChange={(e) => setNote(e.target.value)}
        ></textarea>
      </div>
      <div className="detailsColumn">
        {addressComplete === false ? (
          <div>
            <h2>Voer gegevens in:</h2>
            <form onSubmit={handleSubmitDetails}>
              <p>Contactgegevens</p>
              <br />
              <div className="nameWrapper">
              <input
                type="text"
                placeholder="Voornaam"
                required
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <input
                type="text"
                placeholder="Tussenvoegsel"
                value={preposition}
                onChange={(e) => setPreposition(e.target.value)}
              />
              <input
                type="text"
                placeholder="Achternaam"
                required
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              </div>
              <input
                type="text"
                placeholder="Bedrijfsnaam"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
              <input
                type="email"
                placeholder="E-mailadres"
                required
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
              />
              <input
                type="tel"
                placeholder="Telefoonnummer"
                required
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
              <p>Adresgegevens</p>
              <br />
              <select
                required
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              >
                <option value="" disabled>
                  Land
                </option>
                <option value="NL">Nederland</option>
                <option value="BE">België</option>
              </select>
              <input
                type="text"
                placeholder="Straatnaam"
                required
                value={streetName}
                onChange={(e) => setStreetName(e.target.value)}
              />
              <input
                type="text"
                placeholder="Huisnummer"
                required
                value={houseNumber}
                onChange={(e) => setHouseNumber(e.target.value)}
              />
              <input
                type="text"
                placeholder="Toevoeging huisnummer"
                value={houseNumberAddition}
                onChange={(e) => setHouseNumberAddition(e.target.value)}
              />
              <input
                type="text"
                placeholder="Postcode"
                required
                value={zipcode}
                onChange={(e) => setZipcode(e.target.value)}
              />
              <input
                type="text"
                placeholder="Plaats"
                required
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
                 <label>
                    <input type="checkbox"  
                    checked={differentShippingAddress}  // Attach the state variable
                    onChange={handleDifferentAddressCheckboxChange} />
                    Verzenden naar een ander adres?
                 </label>

                {differentShippingAddress && (

                <div className="differentAddressDiv">
                <p>Contactgegevens</p>
                <br />
                <div className="nameWrapper">
                <input
                  type="text"
                  placeholder="Voornaam"
                  required
                  value={shippingFirstName}
                  onChange={(e) => setShippingFirstName(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Tussenvoegsel"
                  value={shippingPreposition}
                  onChange={(e) => setShippingPreposition(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Achternaam"
                  required
                  value={shippingLastName}
                  onChange={(e) => setShippingLastName(e.target.value)}
                />
                </div>
                <input
                  type="text"
                  placeholder="Bedrijfsnaam"
                  value={shippingCompanyName}
                  onChange={(e) => setShippingCompanyName(e.target.value)}
                />
                <p>Adresgegevens</p>
                <br />
                <select
                  required
                  value={shippingCountry}
                  onChange={(e) => setShippingCountry(e.target.value)}
                >
                  <option value="" disabled>
                    Land
                  </option>
                  <option value="NL">Nederland</option>
                  <option value="BE">België</option>
                </select>
                <input
                  type="text"
                  placeholder="Straatnaam"
                  required
                  value={shippingStreetName}
                  onChange={(e) => setShippingStreetName(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Huisnummer"
                  required
                  value={shippingHouseNumber}
                  onChange={(e) => setShippingHouseNumber(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Toevoeging huisnummer"
                  value={shippingHouseNumberAddition}
                  onChange={(e) => setShippingHouseNumberAddition(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Postcode"
                  required
                  value={shippingZipcode}
                  onChange={(e) => setShippingZipcode(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Plaats"
                  required
                  value={shippingCity}
                  onChange={(e) => setShippingCity(e.target.value)}
                />
                </div>

                )}

              <button className='checkout-btn' type="submit">Bevestigen</button>
            </form>
          </div>
        ) : (
          <div id="orderSummary">
            {differentShippingAddress ? (
            <h2>Factuur gegevens:</h2>
            ) : (
            <h2>Bestelling gegevens:</h2>)}
            <h3>Contactgegevens:</h3>
            <div className="orderGrid">
            <p><strong>Voornaam:</strong></p><p>{firstName}</p>
            <p><strong>Tussenvoegsel:</strong></p><p>{preposition}</p>
            <p><strong>Achternaam:</strong></p><p>{lastName}</p>
            {companyName !== '' && <>
                <p><strong>Bedrijfsnaam:</strong></p><p>{companyName}</p>
            </>}
            <p><strong>Email:</strong></p><p>{emailAddress}</p>
            <p><strong>Telefoon:</strong></p><p>{phoneNumber}</p>
            </div>
            <h3>Adresgegevens:</h3>
            <div className="orderGrid">
                <p><strong>Straatnaam:</strong></p><p>{streetName}</p>
                <p><strong>Huisnummer:</strong></p><p>{houseNumber}</p>
                <p><strong>Toevoeging:</strong></p><p>{houseNumberAddition}</p>
                <p><strong>Postcode:</strong></p><p>{zipcode}</p>
                <p><strong>Plaats:</strong></p><p>{city}</p>
                <p><strong>Land:</strong></p><p>{country}</p>
            </div>

            {differentShippingAddress && (
              <div id="orderSummary">
                <h2>Verzend gegevens:</h2>
                
                <h3>Contactgegevens:</h3>
                <div className="orderGrid">
                  <p><strong>Voornaam:</strong></p><p>{shippingFirstName}</p>
                  <p><strong>Tussenvoegsel:</strong></p><p>{shippingPreposition}</p>
                  <p><strong>Achternaam:</strong></p><p>{shippingLastName}</p>
                  {shippingCompanyName && shippingCompanyName !== '' && (
                    <>
                      <p><strong>Bedrijfsnaam:</strong></p><p>{shippingCompanyName}</p>
                    </>
                  )}
                </div>
                
                <h3>Adresgegevens:</h3>
                <div className="orderGrid">
                  <p><strong>Straatnaam:</strong></p><p>{shippingStreetName}</p>
                  <p><strong>Huisnummer:</strong></p><p>{shippingHouseNumber}</p>
                  <p><strong>Toevoeging:</strong></p><p>{shippingHouseNumberAddition}</p>
                  <p><strong>Postcode:</strong></p><p>{shippingZipcode}</p>
                  <p><strong>Plaats:</strong></p><p>{shippingCity}</p>
                  <p><strong>Land:</strong></p><p>{shippingCountry}</p>
                </div>
              </div>
            )}

            <button className='checkout-btn' onClick={() => setAddressComplete(false)}>Wijzig</button>
          </div>
        )}
        <div id="payBox">
          <PaymentMethodSelector
            selectedMethod={selectedPaymentMethod}
            setSelectedMethod={setSelectedMethod}
          />
        </div>
        <div>
          <h2>Verzending:</h2>
         
          {/* <ShippingOptions
            shippingOption={shippingOption}
            setShippingOption={setShippingOption} 
            addressComplete={addressComplete}
            houseNumber={houseNumber}
            houseNumberAddition={houseNumberAddition}
            streetName={streetName}
            city={city}
            zipCode={zipcode}
            country={country}    
          /> */}

            <ShippingOptionsBasic
            shippingOption={shippingOption}
            setShippingOption={setShippingOption}   
            orderPrice={totalPrice} 
          />


        </div>      

        <div className="confirmWrapper">

        <p className="terms">Door op de knop "Plaats bestelling" te klikken, geeft u aan dat u ons 
        &nbsp;<a href="/privacybeleid" target="_blank">privacybeleid</a> en <a href="/retourbeleid" target="_blank">retourbeleid</a>&nbsp;
          heeft gelezen en begrepen en hiermee akkoord gaat.</p>

          <label>
          <input 
            type="checkbox" 
            checked={confirmedAge} 
            onChange={handleAgeCheckboxChange} 
            required 
          />
          Ik verklaar hierbij dat ik 18 jaar of ouder ben op het moment van de aankoop.*
        </label>

        <button className="checkout-btn"  disabled={(!canPlaceOrder || isOrdering )} onClick={() => placeOrder()}>Plaats bestelling</button>
        <div id="orderLoadingBox">
        <ClipLoader color="#3498db" loading={isOrdering} size={15} />
        </div>

        <p id="orderStatusMessage">{statusMessage}</p>
        <p id="orderStatusMessage">{couponStatusMessage}</p>

          {statusMessage && (
            <Link to="https://pulcinos.nl/cart">
              <p className="edit-order-btn">Bewerk bestelling</p>
            </Link>
          )}

        </div>
      </div>
    </div>
  </div>
  </>
  );
};

export default OrderDetails;
